import { matchRoutes, type RouteMatch } from "react-router";
import _ from "lodash";
import type { FuseRouteObjectType } from "@fuse/core/FuseLayout/FuseLayout";
import routes from "@/configs/configRotas/config-rotas";

type FuseRouteMatchType = RouteMatch & {
	route: FuseRouteObjectType;
};

/**
 * Utility function to retrieve and merge or replace a specific route parameter from matched routes.
 *
 * @param pathname The current pathname
 * @param key The key of the parameter to merge or replace (e.g., 'settings', 'auth')
 * @param useMerge Whether to merge the parameter (using lodash merge) or replace it
 * @returns The merged or replaced parameter data of type T
 */
export function getFuseRouteParamUtil<T>(pathname: string, key: keyof FuseRouteObjectType, useMerge = true): T {
	const matchedRoutes = matchRoutes(routes, pathname) as FuseRouteMatchType[] | null;

	return matchedRoutes
		? matchedRoutes.reduce((acc, match) => {
				const routeParam = match.route[key] as T;

				if (routeParam === undefined) return acc;
				if (!useMerge || routeParam === null) return routeParam;

				return _.merge(acc || {}, routeParam);
			}, {} as T)
		: ({} as T);
}
